import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { OnDestroy, OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { JsonEditorOptions, JsonEditorComponent } from 'angular4-jsoneditor/jsoneditor/jsoneditor.component';

import 'brace/mode/json'; // Modo xml para AceEditor
import { AlertService, GrowlType } from '../../../infrastructure/services/alert.service';

export interface SelectCrudType {
  label: string;
  options: OptionCrudType[];
}

export interface OptionCrudType {
  value: any;
  description: string;
}

@Component({
  selector: 'sx-crud-list-builder',
  templateUrl: 'crudListBuilder.component.html'
})
export class CrudListBuilderComponent implements OnDestroy, OnInit {


  /**
   * Reference to JSON editor
   */
  @ViewChild(JsonEditorComponent) jsonEditor: JsonEditorComponent;

  /**
   * Label that will be shown heading the component
   */
  @Input() title = '';

  /**
   * Labels fot inputs
   */
  @Input() components: string[] = ['Key', 'Value'];

  // @Input() classes: string[] = ['col-md-4', 'col-md-4'];

  @Input() viewData = true;

  /**
    * Key with which the values of the inputs will be associated
    * respectively, the first key goes with the first input and the
    * second with the second
   */
  @Input() structure: string[] = ['key', 'value'];

  @Input() showLabels = true;

  @Output() customEvent: EventEmitter<any[]> = new EventEmitter<any[]>();

  showConfirm = [];

  /**
   * Flag to tooglear the extra info component
   */
  advanced = false;



  /**
   * Treatment for the items, receive a string,
   * transform it into an array to show it and manipulate it
   * inside the component. When it returns, it becomes a string again.
   */
  _items: any[] = [];
  get items(): string {
    return JSON.stringify(this._items);
  }

  @Input('items')
  set items(valu: string) {
    // If the parsing of the string fails, we capture the error and initialize the empty array
    try {
      this._items = JSON.parse(valu);
    } catch (e) {
      if (valu) {
        const item = { value: valu, desc: '' };
        const array = [];
        array.push(item);
        this._items = JSON.parse(JSON.stringify(array));
      } else {
        this._items = [];
      }
    }
  }

  /**
   * Auxiliary item to be used to push new items
   */
  newItem = {};

  editorOptions;

  constructor(private dragulaService: DragulaService, private alertService: AlertService) {

    this.editorOptions = new JsonEditorOptions();
    this.editorOptions.search = false;
    this.editorOptions.onChange = () => {
      // Cuando cambia el texto, intentamos parsear el texto
      // si falla no se actualiza el modelo, y se mustra un alert
      try {
        const obj = JSON.parse(this.jsonEditor.getText());
        this._items = obj;
      } catch (ex) {
        alertService.showGrowl({
          type: GrowlType.DANGER,
          body: ex.message,
        });
      }
    };

    this.editorOptions.modes = ['view', 'code', 'form'];
  }

  ngOnInit() {
    this.dragulaService.setOptions(`items-bag-${this.title}`, {
      moves: (el, source, handle, sibling) => handle.className.includes('drag'),
    });
  }

  ngOnDestroy() {
    this.dragulaService.destroy(`items-bag-${this.title}`);
  }

  /**
   * Add new element to list
   */
  add() {
    this._items.push(this.newItem);
    this.newItem = {};
  }

  /**
   * Remove the element in the indicated position
   * @param index index of the item to be deleted
   */
  remove(index) {
    this._items.splice(index, 1);
    this.customEvent.emit(this._items);
    this.showConfirm[index] = false;
  }

  /**
   * Verify the object is instance of SelectCrudType
   * @param object
   */
  isSelectType(object): boolean {
    return object.hasOwnProperty('label') && object.hasOwnProperty('options');
  }

  /**
   * Calculate the column value for the bootstrap class
   * @param value
   */
  calculateCol(value): number {
    const col = 12 / (value.length + 1);
    return col > 1 ? col : 1;
  }

  alignButtons() {
    return this.showLabels ? 'mt-4' : '';
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/crudListBuilder/crudListBuilder.component.ts